module.exports = __webpack_public_path__ + "img/1.2b6e2c85.jpg";